import React, { useState, useEffect } from 'react';
import { useI18n } from '@/lib/i18n';

/** Fetches the latest 5 cloudcasts from a Mixcloud user feed URL. */
function useMixcloudEpisodes(feedUrl) {
  const [episodes, setEpisodes] = useState([]);

  useEffect(() => {
    if (!feedUrl) return;
    const match = feedUrl.match(/mixcloud\.com\/([^/]+)/i);
    if (!match) return;
    const username = match[1];
    let active = true;
    fetch(`https://api.mixcloud.com/${username}/cloudcasts/?limit=5`)
      .then((r) => r.json())
      .then((data) => {
        if (active) setEpisodes(data?.data || []);
      })
      .catch(() => {
        if (active) setEpisodes([]);
      });
    return () => { active = false; };
  }, [feedUrl]);

  return episodes;
}

/**
 * "Replays" section — embeds the latest 5 Mixcloud episodes for a show.
 * Hidden when mixcloud_feed is empty or no episodes are found.
 */
export default function Replays({ mixcloudFeed }) {
  const { lang } = useI18n();
  const es = lang === 'es';
  const episodes = useMixcloudEpisodes(mixcloudFeed);

  if (!mixcloudFeed || !episodes.length) return null;

  return (
    <div className="mt-10">
      <h2 className="text-black text-sm font-black tracking-widest uppercase mb-4">
        {es ? 'REPOSIONES' : 'REPLAYS'}
      </h2>
      <div className="space-y-4">
        {episodes.map((ep) => (
          <iframe
            key={ep.key}
            title={ep.name}
            src={`https://player-widget.mixcloud.com/widget/iframe/?feed=${encodeURIComponent(`https://www.mixcloud.com${ep.key}`)}`}
            className="w-full rounded-xl"
            style={{ height: 120, border: 0 }}
            loading="lazy"
          />
        ))}
      </div>
    </div>
  );
}